import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {api} from '../lib/api';
import {loginAvailabilityMessage, loginErrorMessage, SIGN_IN_UNAVAILABLE} from '../lib/loginStatus';

const SHARDA_LOGO = "https://customer-assets.emergentagent.com/job_prodfabrix/artifacts/mi0mx8zz_image.png";

export default function StabilityLoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [availabilityMessage, setAvailabilityMessage] = useState('');
  useEffect(() => {
    let cancelled = false;
    api.get('/api/fresh-start/status').then(({data}) => {
      if (!cancelled) setAvailabilityMessage(loginAvailabilityMessage(data));
    }).catch(() => {
      if (!cancelled) setAvailabilityMessage(SIGN_IN_UNAVAILABLE);
    });
    return () => { cancelled = true; };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    const submitted = new FormData(event.currentTarget);
    const submittedUsername = String(submitted.get('username') || '').trim();
    const submittedPassword = String(submitted.get('password') || '');
    if (!submittedUsername || !submittedPassword) {
      setError('Enter your username and password.');
      return;
    }
    setError("");
    setIsSubmitting(true);
    try {
      await login(submittedUsername, submittedPassword);
      navigate("/dashboard");
    } catch (requestError) {
      setError(loginErrorMessage(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page" data-testid="stability-login-page" style={{'--ink-muted': '0 0% 62%'}}>
      <div className="login-card" data-testid="stability-login-card">
        <div className="login-logo">
          <img src={SHARDA_LOGO} alt="Sharda Production" data-testid="login-brand-logo" />
          <h1 className="login-title" data-testid="login-title">Sharda Production</h1>
          <p className="login-subtitle" data-testid="login-subtitle">Manufacturing Command Center</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form" data-testid="stability-login-form">
          <div className="form-group">
            <label className="form-label" htmlFor="username-input" data-testid="login-username-label">Username</label>
            <input
              id="username-input"
              name="username"
              required
              className="form-input"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              data-testid="stability-username-input"
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="password-input" data-testid="login-password-label">Password</label>
            <input
              id="password-input"
              name="password"
              required
              className="form-input"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              data-testid="stability-password-input"
            />
          </div>

          {error && (
            <div className="login-error" role="alert" data-testid="stability-login-error">{error}</div>
          )}
          {!error && !isSubmitting && availabilityMessage && <p role="status" data-testid="login-availability-status" style={{fontSize:13, lineHeight:1.6}}>{availabilityMessage}</p>}
          {isSubmitting && <p role="status" data-testid="login-progress-status" style={{fontSize:13, lineHeight:1.6}}>Signing in. Please keep this page open.</p>}

          <button className="btn-primary" type="submit" disabled={isSubmitting} data-testid="stability-login-submit-button" style={{ width: "100%", padding: "14px", fontSize: 14 }}>
            {isSubmitting ? 'SIGNING IN…' : 'SIGN IN'}
          </button>
        </form>

        <div data-testid="login-app-version" style={{ marginTop: 32, textAlign: "center", fontSize: 11, color: "hsl(var(--ink-muted))", fontFamily: "'JetBrains Mono', monospace" }}>
          v2.0 // SHARDA ERP SYSTEM
        </div>
      </div>
    </div>
  );
}
